// extracted by mini-css-extract-plugin
export default {"video":"AuthHero-module__video_AISdy"};